import { MultiCountryData } from '../shared/models/multi-country-data';

export const environment = {
    lastLanguage: 'es',
    currentLanguage: 'es',
    hideHeaderAndFooter: true,
    production: true,
    version: '2.1.6.0-20240822-qa',
    captchaKey: '6Lfm628qAAAAAKjmRZV0XfXMwyIh5Lh7txzq6qId',
    test: 'qa',
    googleAnalytics: 'G-L2G7FL9MP3',
    googleAnalyticsTechnical: 'G-JX2GHBQLYG',
    rol: '',
    expressUserData: [],
    pathCertificate: 'assets/certs/public-qa.txt',
    multiCountryData: [] as MultiCountryData[],
    basePath: '/',
    apigoogle: 'AIzaSyBLMW-yZQI4A_mnrDCugdzhMl1RPLjrJ4w',
    linkEntregaPage: 'https://linkdepago.forzadeliveryexpress.com',
    apiLinkEntrega: 'https://backendlinkpago.forzadeliveryexpress.com/api/V1',
    apiBackApp: 'https://backendlinkpago.forzadeliveryexpress.com/app/api/V1',
    linkQrAfiliatePage: 'https://qa-portal.forzadeliveryexpress.com/clubForza/',
    storeLink: 'https://qa-tienda.forzadeliveryexpress.com',
    userWOLGT: {
        IdAccount: 78690,
        IdCustomer: 68508,
    },
    userWOLHN: {
        IdAccount: 78696,
        IdCustomer: 68515,
    },
    routes: [
        {
            path: '',
            loadComponent: () =>
                import('../pages/kiosko/login/login.component').then(
                    (m) => m.LoginComponent
                ),
        },
        {
            path: 'login',
            loadComponent: () =>
                import('../pages/kiosko/login/login.component').then(
                    (m) => m.LoginComponent
                ),
        },
        {
            path: 'scan-guide',
            loadComponent: () =>
                import('../pages/kiosko/scan-guide/scan-guide.component').then(
                    (m) => m.ScanGuideComponent
                ),
        },
        {
            path: 'pagina-no-encontrada',
            loadComponent: () =>
                import('../pages/not-found/not-found.component').then(
                    (m) => m.NotFoundComponent
                ),
        },
        {
            path: '**',
            loadComponent: () =>
                import('../pages/not-found/not-found.component').then(
                    (m) => m.NotFoundComponent
                ),
        },
    ],
};

export enum Constants {
    api = 'https://qa-portal.forzadeliveryexpress.com/fd/Home.aspx/API',
    apiHN = 'https://qa-portal.forzadeliveryexpress.com/fdHN/Home.aspx/API',
    sesionTime = 900000, // 15 * 60 * 1000 = 900000 milisegundos = 15 minutos
    sesionTimeExpress = 32400000, // 9 horas * 60 minutos  * 60 segundos * 1000 milisegundos = 32400000
}
